import Animatori from "@/pages/Animatori";

export default function Responsabili() {
  return <Animatori mode="responsabili" />;
}
